import { render, staticRenderFns } from "./ShippingDetailsBlock.vue?vue&type=template&id=0a6361a8&scoped=true"
import script from "./ShippingDetailsBlock.vue?vue&type=script&lang=js"
export * from "./ShippingDetailsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6361a8",
  null
  
)

export default component.exports